.assignee-popover {
    width: 250px;
    overflow-y: auto;
}

.assignee-popover ul {
    max-height: 300px;
}

.task-row-icon-container {
    width: 18px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 2px;
    align-items: center;
}

.task-row-status {
    padding-top: 5px;
    display: flex;
    overflow: hidden;
    min-height: fit-content;
}

.read-more-button {
    min-width: 64px;
}

.description-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: fit-content;
    max-width: 100%;
}

.task-row-creator-entity {
    margin-left: -8px;
}
